<!--suppress HtmlUnknownBooleanAttribute -->
<div class="container" *ngIf="!pageLoading">

  <div class="request-info my-5 text-dark">
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'Request No' | translate}}:</div>
      <div class="col-3">{{newSubAccountRequest.id}}</div>
    </div>
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'Maximum users count for this request' | translate}}:</div>
      <div class="col-3">{{newSubAccountRequest.count}}</div>
    </div>
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'Used Count' | translate}}:</div>
      <div class="col-3">{{assignedSubAccounts.length}}</div>
    </div>
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'Payment Date' | translate}}:</div>
      <div class="col-3">{{newSubAccountRequest.paymentDate | date:'yyyy-MM-dd'}}</div>
    </div>
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'Invoice No' | translate}}:</div>
      <div class="col-3"><a target="_blank" class="text-primary" [href]="env.getPaymentWebUrl() + '/pay/order/' + newSubAccountRequest.invoiceNumber ">{{newSubAccountRequest.invoiceNumber}}</a></div>
    </div>
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'Total' | translate}}:</div>
      <div class="col-3">{{newSubAccountRequest.totalAmount | number:'1.2-2'}} <sup>{{'SAR' | translate}}</sup></div>
    </div>
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'VAT Amount' | translate}}:</div>
      <div class="col-3">{{newSubAccountRequest.totalVatAmount | number:'1.2-2'}} <sup>{{'SAR' | translate}}</sup></div>
    </div>
    <div class="row my-2" *ngIf="newSubAccountRequest">
      <div class="col-2">{{'Payment Method' | translate}}:</div>
      <div class="col-3">{{newSubAccountRequest.paidBy == 'MerchantWallet' ? ('Wallet Balance' | translate) : ('Bank Card' | translate)}}</div>
    </div>
  </div>

  <div class="row">
    <button class="btn btn-primary" (click)="assignNew()" translate>Add New Sub Account</button>&ngsp;
    &ngsp;<button class="btn btn-secondary mx-1" (click)="closeWindow()" translate>Close</button>&ngsp;
    <div class="col-1" *ngIf="loading">
      <button type="button" class="btn btn-primary">
        <div class="mx-auto spinner-grow text-dark align-self-center loader-lg"></div>
      </button>
    </div>
  </div>

  <table *ngIf="assignedSubAccounts" border="1" class="w-100 mt-4 bg-white" cellpadding="5">
    <tr>
      <th translate>Name</th>
      <th translate>Mobile</th>
      <th translate>Gov Id</th>
      <th translate>Account Type</th>
      <th translate>Create Date</th>
      <!--      <th translate>Action</th>-->
    </tr>
    <tr *ngFor="let assignedSubAccount of assignedSubAccounts">
      <td translate>{{assignedSubAccount.fullName}}</td>
      <td translate>{{assignedSubAccount.mobile}}</td>
      <td translate>{{assignedSubAccount.govId}}</td>
      <td translate>{{assignedSubAccount.accountType}}</td>
      <td translate>{{assignedSubAccount.createDate | date:'YYYY-MM-dd'}}</td>
    </tr>
  </table>
</div>

<div class="modal" #addModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" translate>Assign Sub Account</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="assignFormGroup">
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <input [ngClass]="{'is-invalid' : submitted && f.name.errors}" type="text" formControlName="name" class="form-control" id="name" placeholder="{{'Name' | translate}}">
                <small *ngIf="submitted && f.name.errors && f.name.errors.required" class="invalid-feedback" translate>Required field</small>
                <small *ngIf="submitted && f.name.errors && f.name.errors.pattern" class="invalid-feedback" translate>Invalid value</small>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <input [ngClass]="{'is-invalid' : submitted && f.mobile.errors}" type="text" formControlName="mobile" class="form-control" id="mobile" placeholder="{{'Mobile' | translate}}">
                <small *ngIf="submitted && f.mobile.errors && f.mobile.errors.required" class="invalid-feedback" translate>Required field</small>
                <small *ngIf="submitted && f.mobile.errors && f.mobile.errors.pattern" class="invalid-feedback" translate>Invalid value</small>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <input [ngClass]="{'is-invalid' : submitted && f.govId.errors}" type="text" formControlName="govId" class="form-control" id="govId" placeholder="{{'Gov Id' | translate}}">
                <small *ngIf="submitted && f.govId.errors && f.govId.errors.required" class="invalid-feedback" translate>Required field</small>
                <small *ngIf="submitted && f.govId.errors && f.govId.errors.pattern" class="invalid-feedback" translate>Invalid value</small>
              </div>
            </div>
            <div class="col-6" *ngIf="otpSent">
              <div class="form-group">
                <input [ngClass]="{'is-invalid' : submitted && f.absherOtp.errors}" type="text" formControlName="absherOtp" class="form-control" id="absherOtp" placeholder="{{'Absher OTP' | translate}}">
                <small *ngIf="submitted && f.absherOtp.errors && f.absherOtp.errors.required" class="invalid-feedback" translate>Required field</small>
                <small *ngIf="submitted && f.absherOtp.errors && f.absherOtp.errors.pattern" class="invalid-feedback" translate>Invalid value</small>
              </div>
            </div>
<!--            <div class="col-6">-->
<!--              <div class="form-group">-->
<!--                <select [ngClass]="{'is-invalid' : submitted && f.accountType.errors}" formControlName="accountType" class="form-control" id="accountType">-->
<!--                  <option value="Accountant" translate>Accountant</option>-->
<!--                  <option value="Sales" translate>Sales</option>-->
<!--                </select>-->
<!--                <small *ngIf="f.accountType.value == 'Staff'" translate>Only generate invoices and manage products.</small>-->
<!--                <small *ngIf="f.accountType.value == 'Accountant'" translate>Has read-only access to all information</small>-->
<!--                <small *ngIf="submitted && f.accountType.errors && f.accountType.errors.required" class="invalid-feedback" translate>Required field</small>-->
<!--                <small *ngIf="submitted && f.accountType.errors && f.accountType.errors.pattern" class="invalid-feedback" translate>Invalid value</small>-->
<!--              </div>-->
<!--            </div>-->
          </div>
          <div class="row">
            <div class="col-12">
              <div *ngIf="getStatus() == 'progress'" class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
              <div *ngIf="getStatus() == 'success'" class="text-success m-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <div *ngIf="getStatus() == 'idle'" class="text-info m-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-circle">
                  <circle cx="12" cy="12" r="10"></circle>
                </svg>
              </div>
              <div *ngIf="getStatus() == 'error'" class="text-danger m-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-octagon">
                  <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                  <line x1="15" y1="9" x2="9" y2="15"></line>
                  <line x1="9" y1="9" x2="15" y2="15"></line>
                </svg>
                <span class="text-danger">{{getResponse() | translate}}</span>
              </div>
            </div>
          </div>
        </form>
        <!---->
      </div>
      <div class="modal-footer">
        <button *ngIf="!otpSent" class="btn btn-primary" (click)="submit()" translate>Submit</button>
        <button *ngIf="otpSent" class="btn btn-primary" (click)="submitOtp()" translate>Confirm</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close" (click)="resetForm()" translate>Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal" #infoModal tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{modalTitle}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>{{modalMsg}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="okFunction? okFunction() : ''" translate>Close</button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="pageLoading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>
